const getPrType = (disablePR = true) => {
  return [
    { type: "0", label: "Không phải PR", value: "0", isDisabled: disablePR },
    { type: "1", label: "Bài PR Top 1 Trang chủ", value: "1", expiredTime: 2, limit: 1, prprice: 30000000 },
    { type: "2", label: "Bài PR Top 2 3 Trang chủ", value: "2", expiredTime: 2, limit: 2, prprice: 20000000 },
    {
      type: "3",
      label: "Bài PR Top 4 5 6 Trang chủ",
      value: "3",
      expiredTime: 2,
      limit: 3,
      prprice: 15000000
    },
    { type: "4", label: "Bài loại 4 trước 07/2023", value: "4", expiredTime: 4, limit: 3 },
    { type: "5", label: "Bài PR stream 1", value: "5", expiredTime: 4, limit: 1, prprice: 12000000 },
    { type: "6", label: "Bài PR stream 2", value: "6", expiredTime: 4, limit: 1, prprice: 10000000 },
    { type: "7", label: "Bài PR stream 3", value: "7", expiredTime: 4, limit: 2, prprice:  8000000 },
    { type: "8", label: "Bài PR stream 4", value: "8", expiredTime: 4, limit: 1, prprice:  6000000 },
    { type: "9", label: "Bài PR tiểu mục", value: "9", expiredTime: 2, limit: 1, prprice:  4000000 },
    { type: "10", label: "Bài PR Special", value: "10", expiredTime: 4, limit: 3, prprice: 20000000 },
  ];
};

export default getPrType